import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ConfigOcorrenciaAuto } from '../../comum/modelos/config-ocorrencia-auto';
import { OcorrenciasService } from '../ocorrencias.service';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-agendamento-ocorrencia',
  templateUrl: './listar-agendamento-ocorrencia.component.html',
  styleUrls: ['./listar-agendamento-ocorrencia.component.css']
})
export class ListarAgendamentoOcorrenciaComponent implements OnInit {
  filtroPesquisaNomeRotina: string;
  agendamentosOcorrencia: ConfigOcorrenciaAuto[];
  statusCode: number;

  public paginacao: Paginacao;
  public evento: Evento;
  public loading = false;

  constructor(
    private _ocorrenciasService: OcorrenciasService,
    private _comumService: ComumService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.agendamentosOcorrencia = new Array<ConfigOcorrenciaAuto>();
    this.paginacao = new Paginacao();
    this.evento = this._comumService.evento;
    this.loading = false;
    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 2000);
    }
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.fetchData();
  }

  removerAgendamentoOcorrencia(configOcorrencia: ConfigOcorrenciaAuto): void {
    const self = this;
    this.confirmationService.confirm({
      message: 'Deseja excluir este agendamento?',
      accept: () => {
        this._ocorrenciasService.apagarConfigOcorrenciaAutoHttp(configOcorrencia.idConfigOcorrenciaAuto)
          .subscribe(response => {
            self.statusCode = response.status;
            self._comumService.evento.deletar = true;
            self.agendamentosOcorrencia = new Array<ConfigOcorrenciaAuto>();
            self.fetchData();
            self.router.navigate(['listar-agendamento-ocorrencias']);
            self.loading = false;
            setTimeout(() => {
              self.evento.limparEventos();
            }, 3000);
          }, errorCode => {
            self.statusCode = errorCode;
            self.loading = false;
          });
      },
      reject: () => {
      }
    });
  }

  fetchData() {
    this.loading = true;
    this._ocorrenciasService.obterAgendamentosOcorrenciaAutoHttp(parseInt(this._cookieService.get('idCliente')))
      .subscribe((agendamentos) => {
        this.agendamentosOcorrencia = agendamentos;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeRotina = filtro.value;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/listar-agendamento-ocorrencia/listar-agendamento-ocorrencia.component.ts